'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertyExtractor = require('./property-extractor');

/**
 * load property of object.
 */

var PropertyLoader = function () {

  /**
   * initialize with loader.
   * @param {Loader} loader is impl load function.
   */
  function PropertyLoader(loader) {
    _classCallCheck(this, PropertyLoader);

    this._loader = loader;
  }

  /**
   * load property of package.json.
   * @param {String} propName
   * @returns {Promise} property of package.json
   */


  _createClass(PropertyLoader, [{
    key: 'loadProp',
    value: function loadProp(propName) {
      return this._loader.load().then(function (pkgJson) {
        return new PropertyExtractor(pkgJson);
      }).then(function (handler) {
        return handler.extractProp(propName);
      });
    }

    /**
     * load properties of package.json.
     * @param {Array} propNames
     * @returns {Promise} properties of package.json
     */

  }, {
    key: 'loadProps',
    value: function loadProps(propNames) {
      return this._loader.load().then(function (pkgJson) {
        return new PropertyExtractor(pkgJson);
      }).then(function (handler) {
        return handler.extractProps(propNames);
      });
    }

    /**
     * load keys of property of package.json.
     * @param {String} propName
     * @returns {Promise} keys of property of package.json
     */

  }, {
    key: 'loadPropKeys',
    value: function loadPropKeys(propName) {
      return this._loader.load().then(function (pkgJson) {
        return new PropertyExtractor(pkgJson);
      }).then(function (handler) {
        return handler.extractPropKeys(propName);
      });
    }

    /**
     * load keys of properties of package.json.
     * @param {Array} propName
     * @returns {Promise} keys of property of package.json
     */

  }, {
    key: 'loadPropsKeys',
    value: function loadPropsKeys(propNames) {
      return this._loader.load().then(function (pkgJson) {
        return new PropertyExtractor(pkgJson);
      }).then(function (handler) {
        return handler.extractPropsKeys(propNames);
      });
    }
  }]);

  return PropertyLoader;
}();

module.exports = PropertyLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dpndon/dist/util/property-loader.js
// module id = 778
// module chunks = 0